import * as types from "../../types/stores.types";

const initialState = {
    status_show_modal: false,
    loader_modal: false,
    food_packs: []
}
const modalMyFoodPacks = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_STATUS_SHOW_MODAL_MY_FOOD_PACKS:
            return {...state, status_show_modal: action.payload.status_show_modal};
        case types.CHANGE_LOADER_MODAL_MY_FOOD_PACKS:
            return {...state, loader_modal: action.loader_modal};
        case types.PUT_SET_MY_FOOD_PACKS:
            return {...state, food_packs: action.food_packs};
        default:
            return state;
    }
}

export default modalMyFoodPacks;